import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phone', standalone: true })
export class PhonePipe implements PipeTransform {
  /**
   * Formats a phone number string to US format: (000) 000-0000
   * Removes all non-numeric characters and formats to standard US phone format
   *
   * @param value - Phone number in any format (e.g., 0000000000, 000 000 0000, (000)0000000)
   * @returns Formatted phone number as (000) 000-0000, or empty string if invalid
   *
   * @example
   * PhonePipe.formatPhone('1234567890') // returns '(123) 456-7890'
   * PhonePipe.formatPhone('123 456 7890') // returns '(123) 456-7890'
   * PhonePipe.formatPhone('(123)456-7890') // returns '(123) 456-7890'
   */
  static formatPhone(value: string | number | null | undefined): string {
    if (value == null || value === '') return '';

    const digitsOnly = String(value).replace(/\D/g, '');

    if (digitsOnly.length !== 10) return value?.toString() || '';

    return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`; // Format as (000) 000-0000
  }

  transform(value: string | number | null | undefined): string {
    return PhonePipe.formatPhone(value);
  }
}
